import Text from 'UIKit/Text'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { ColumnCenter } from 'layout/Components/Column'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import theme from 'theme'
import RewardThumbnail from './RewardThumbnail'

enum RewardStatus {
  Claimed = 'Claimed',
  Claimable = 'Claimable',
  Lock = 'Lock',
  HighLightClaimed = 'HighLightClaimed',
  HighLightClaimable = 'HighLightClaimable',
  HighLightLock = 'HighLightLock',
}

const RewardCard: React.FC<{
  rewardDetail: any
  isActive: boolean
  isHighlight: boolean
}> = ({ rewardDetail, isActive, isHighlight }) => {
  const { isMobile } = useMatchBreakpoints()

  const isFocusBackground = isActive
  const { t } = useTranslation()

  const rewardStatus = useMemo(() => {
    if (rewardDetail.userData?.isClaimed) return isHighlight ? RewardStatus.HighLightClaimed : RewardStatus.Claimed
    if (isActive) return isHighlight ? RewardStatus.HighLightClaimable : RewardStatus.Claimable
    return isHighlight ? RewardStatus.HighLightLock : RewardStatus.Lock
  }, [rewardDetail.userData?.isClaimed, isActive, isHighlight])

  return (
    <CardStyled width={!isMobile ? '102px !important' : 'unset'}>
      <Text
        fontSize={theme.typography.fontSizes.label_sm}
        fontWeight={theme.typography.fontWeights.semibold}
        color={isActive ? theme.colors.fg_primary : theme.colors.fg_secondary}
        mb={theme.spacing.fix_075}
      >
        {t('Day {{day}}', {
          day: rewardDetail.day,
        })}
      </Text>
      <RewardCardStyled
        p={`${theme.spacing.fix_150} ${theme.spacing.fix_050} ${theme.spacing.fix_050} ${theme.spacing.fix_050}`}
        borderRadius={theme.radii.small}
        height={isMobile ? 'unset' : '80px'}
        width="100%"
        justifyContent="center !important"
        rewardStatus={rewardStatus}
      >
        <RewardThumbnail rewardDetail={rewardDetail} />

        {rewardDetail.displayName && (
          <Text
            color={isFocusBackground ? '#fff' : theme.colors.textTertiary}
            fontSize={theme.typography.fontSizes.label_sm}
            fontWeight={theme.typography.fontWeights.semibold}
            mt={theme.spacing.fix_075}
            textAlign="center"
            lineHeight={theme.typography.lineHeights.label}
          >
            {rewardDetail.displayName}
          </Text>
        )}
      </RewardCardStyled>
    </CardStyled>
  )
}

const BASE_URL = '/images/dailyCheckin/cardBackground'

const getCardBackground = (rewardStatus: RewardStatus) => {
  switch (rewardStatus) {
    case RewardStatus.Claimed:
      return `url('${BASE_URL}/claimed.png')`
    case RewardStatus.Claimable:
      return `url('${BASE_URL}/claimable.png')`
    case RewardStatus.Lock:
      return `url('${BASE_URL}/locked.png')`
    case RewardStatus.HighLightClaimed:
      return `url('${BASE_URL}/featured-claimed.png')`
    case RewardStatus.HighLightClaimable:
      return `url('${BASE_URL}/featured-claimable.png')`
    case RewardStatus.HighLightLock:
      return `url('${BASE_URL}/featured-locked.png')`
    default:
      return ''
  }
}

const RewardCardStyled = styled(ColumnCenter)<{ rewardStatus: RewardStatus }>`
  position: relative;
  overflow: hidden;
  justify-content: flex-start !important;
  aspect-ratio: 102 / 80;
  background-image: ${({ rewardStatus }) => getCardBackground(rewardStatus)};
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
`

const CardStyled = styled(ColumnCenter)``

export default RewardCard
